import React from 'react';
import { ServerState } from '@kcdash/shared';

interface StatusBadgeProps {
  state: ServerState | string;
  size?: 'sm' | 'md' | 'lg';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ state, size = 'md' }) => {
  let color = 'bg-neutral-800 text-neutral-400 border-neutral-700';
  let dotColor = 'bg-neutral-500';
  let pulse = false;

  switch (state) {
    case ServerState.ONLINE:
      color = 'bg-emerald-950/60 text-emerald-400 border-emerald-800/80 badge-online';
      dotColor = 'bg-emerald-400';
      pulse = true;
      break;
    case ServerState.STARTING:
    case ServerState.RESTARTING:
      color = 'bg-amber-950/60 text-amber-400 border-amber-800/80';
      dotColor = 'bg-amber-400';
      pulse = true;
      break;
    case ServerState.STOPPING:
      color = 'bg-orange-950/60 text-orange-400 border-orange-800/80';
      dotColor = 'bg-orange-400';
      pulse = true;
      break;
    case ServerState.CRASHED:
      color = 'bg-red-950/60 text-red-400 border-red-800/80 badge-crashed';
      dotColor = 'bg-red-400';
      pulse = false;
      break;
    case ServerState.OFFLINE:
    default:
      color = 'bg-neutral-900 text-neutral-400 border-neutral-800';
      dotColor = 'bg-neutral-600';
      pulse = false;
      break;
  }

  const sizeClasses =
    size === 'sm'
      ? 'text-xs px-2 py-0.5 gap-1.5'
      : size === 'lg'
      ? 'text-sm px-3.5 py-1.5 gap-2.5 font-medium'
      : 'text-xs px-2.5 py-1 gap-2 font-medium';

  return (
    <span
      className={`inline-flex items-center rounded-full border tracking-wide uppercase font-mono ${color} ${sizeClasses}`}
    >
      <span className="relative flex h-2 w-2">
        {pulse && (
          <span
            className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${dotColor}`}
          />
        )}
        <span className={`relative inline-flex rounded-full h-2 w-2 ${dotColor}`} />
      </span>
      {state}
    </span>
  );
};
